/* Version: 3.5.137 */
'use client';
var ADORNMENT_POSITION = {
  LEFT: 'left',
  RIGHT: 'right'
};
var TEXT_ALIGN = {
  LEFT: 'left',
  RIGHT: 'right',
  CENTER: 'center'
};
var INPUT_VARIANT = {
  BASIC: 'basic',
  BASIC_LINE: 'basic_line',
  BASIC_LINE_DASHED: 'basic_line_dashed'
};

export { ADORNMENT_POSITION, INPUT_VARIANT, TEXT_ALIGN };
